import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import type { RouteLocationNormalized } from "vue-router";

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	const hasSearchQuery = to.query && Object.keys(to.query).some(key => typeof to.query[key] === "string" && key === 'search');

	if (hasSearchQuery) {
		const searchQuery = to.query['search'] as string;
		const filters = searchQuery.split('|');
		const newQuery: Record<string, string> = {};

		for(const filter of filters) {
			const [key, value] = filter.split('-');
			if (key && value) {
				newQuery[key] = value;
			}
		}
		delete to.query['search'];
		to.query = { ...to.query, ...newQuery };

		return navigateTo(to, { replace: true });
	}
});
